module.exports = __webpack_public_path__ + "static/media/bg.19a3d5e6.jpg";